import { AbstractControl, ValidatorFn, FormControl } from '@angular/forms';

export function anoEnemValidator(input: number, anoProcesso: number, enemLimiteAnos: number): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
        if ((anoProcesso - input) > enemLimiteAnos) {
            return { 'error': `Permitido somente ${enemLimiteAnos} últimos anos` };
        }

        if (anoProcesso < input) {
            return { 'error': 'Não pode ser maior que o ano atual' };
        }

        return null;
    };
}

export function numeroEnemValidator(input: number): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {

        if (input.toString().length != 12) {
            return { 'error': 'Deve possuir 12 digitos' };
        }

        const string = input.toString();
        let i = 1;
        while (i < string.length) {
            if (string[i] != string[i - 1]) {
                return null;
            }
            i++;
        }
        return { 'error': 'Número inválido' };
    };
}



// WEBPACK FOOTER //
// ./src/app/_shared/processo/enem-validador.directive.ts